import React, { useCallback, useState } from "react";
import { HStack } from "@design-system/HStack/HStack";
import { useIgnoreLoosingAccessToTransaction } from "@hooks/useIgnoreLoosingAccessToTransaction";
import { ModalComponentWithResultProps } from "@helpers/modal";
import { Button } from "@design-system/Button/Button";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Checkbox } from "@design-system/Checkbox/Checkbox";

interface Props extends ModalComponentWithResultProps<boolean> {
    ownerName: string;
}

export const LoosingAccessToTransactionModal: React.FC<Props> = ({
    ownerName,
    close,
}) => {
    const firstName = ownerName.split(" ")[0];
    const { setIgnoreLoosingAccess } = useIgnoreLoosingAccessToTransaction();
    const [isChecked, setIsChecked] = useState(false);

    const onContinue = useCallback(() => {
        if (isChecked) {
            setIgnoreLoosingAccess();
        }
        close(true);
    }, [setIgnoreLoosingAccess, close, isChecked]);

    return (
        <>
            <StandardModalHeader>
                You will lose access to this transaction
            </StandardModalHeader>
            <StandardModalBody>
                <p className="text-prominent">
                    This transaction was initiated by{" "}
                    <strong>{ownerName}</strong>, so if you mark it as Personal,
                    it will be shown on {firstName}'s account only. Are you sure
                    you want to continue?
                </p>

                <Checkbox
                    checked={isChecked}
                    label="Don't show this again"
                    onCheckedChange={setIsChecked}
                />

                <HStack as="footer" justify="between" className="mt-5">
                    <Button
                        variant="secondary"
                        size="md"
                        onClick={() => close(false)}
                    >
                        Cancel
                    </Button>
                    <Button variant="primary" size="md" onClick={onContinue}>
                        Continue
                    </Button>
                </HStack>
            </StandardModalBody>
        </>
    );
};
